import Typography from "antd/lib/typography";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { Calendar as CalendarIcon } from "@sol/uikit/core/icons/Calendar";

type Props = {
    start: string;
    end: string;
    className?: string;
};

export const FollowUpPeriodTag = ({ start, end, className }: Props) => {
    const [t] = useTranslation();

    return (
        <div
            className={clsx(
                "flex items-center justify-center",
                "gap-ant-sm p-ant",
                "border-ant border-ant-secondary",
                "rounded-full bg-white",
                className,
            )}
        >
            <CalendarIcon className="text-primary" />
            <Typography.Text className="text-ant-sm font-ant-strong">
                {t("component.follow-ups.details.FollowUpPeriodTag.period", {
                    startDate: new Date(start),
                    endDate: new Date(end),
                })}
            </Typography.Text>
        </div>
    );
};
